import React, { useEffect, useState } from 'react'
import { GET_SECTION, TYPE_LOOK_UP } from './_hooks';
import { SkeletonLoad } from '../../../../../Library/LoaderPage';
import { AlertNotif } from '../../../../../Library/AlertNotif';
import { HeaderBack } from './HeaderBack';
import { FormCom } from './FormCom';

export function UpdataGrade({ section_id, HandlerBack, HandlerProgressBar }) {
    const [section, setSection] = useState({
        loading: false,
        data: [],
        message: "",
    });
    const [section_com, setSection_com] = useState([]);
    const [type_com, setType_com] = useState([]);
    const [section_cpmk, setSection_cpmk] = useState([]);
    const [total_weight, setTotalWeight] = useState(0);

    const ReloadData = async () => {
        setSection_com([]); setSection_cpmk([]);
        setSection({
            loading: true,
            data: [],
            message: ""
        });
        const param = { section_id };
        const results = await GET_SECTION(param);
        if (results.data && Object.values(results.data).length > 0) {
            const get_row = results.data.find(item => item.section_id === section_id);
            const tWeight = get_row?.section_com?.reduce(
                (acc, obj) => acc + obj.weight,
                0
            );
            setTotalWeight(tWeight);
            setSection_com(get_row?.section_com || []);
            setSection_cpmk(get_row?.section_obe || []);
            setSection({
                loading: false,
                data: get_row,
                message: ""
            });
        } else {
            setSection({
                loading: false,
                data: [],
                message: results.message
            });
        }
    }

    const ReloadTypeComp = async () =>{
        setType_com([]);
        const param = {"grouptype":"com.type"}
        const results = await TYPE_LOOK_UP(param);
        if(results.data && Object.values(results.data).length > 0){
            const data = results.data.filter(item => item.id !== "Formative" && item.id !== "Summative");
            console.log(data);
            setType_com(data);
        }else{
            setType_com([]);
        }
    }

    useEffect(() => {
        ReloadData();
        ReloadTypeComp();
    }, [section_id])

    return (
        <div className="card">
            <div className="card-body p-0">
                <HeaderBack HandlerBack={HandlerBack} totalWeight={total_weight} />

                {(section.loading) ? <SkeletonLoad /> :
                    section.message ? <AlertNotif message={section.message} title="Section Error" /> :
                        section.data && Object.values(section.data).length > 0 ? (
                            <FormCom section_id={section_id} components={section_com} type_com={type_com} HandlerBack={HandlerBack} section_cpmk={section_cpmk} HandlerProgressBar={HandlerProgressBar} />
                        ) : ""}
            </div>
        </div>
    )
}

